import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import HowToOrderMobile from 'components/_special/HowToOrderMobile'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'

import WHowOrderRussianBox from './components/WHowOrderRussianBox'
import { SectionWrapperStyled } from './styles'

const MOBILE_IMAGES_RU = [
  'slider-instruction-v2',
  'slider-test-tube-v2',
  'slider-bag-v2',
]

/**
 * WHowOrder
 *
 * @param {object} props - properties of component
 * @returns {node} WHowOrder
 */
const WHowOrder = props => {
  const { data, pathCdn, index, isSquareHidden } = props
  const { mobile } = useContext(ResizeContext)
  const { paths } = useContext(LocalizationContext)
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapperStyled isOverflowHidden={true}>
      {mobile ? (
        <HowToOrderMobile
          {...{ pathCdn, index }}
          isWhite={true}
          descriptions={data.slider.list}
          images={MOBILE_IMAGES_RU}
          title={data.title}
          squareColor={colors.purpleHeart}
          textColor="light"
          lineColor="light"
        />
      ) : (
        <HowToBlock
          {...{ index, isSquareHidden }}
          title={data.title}
          isFirst={true}
          squareColor={colors.purpleHeart}
          textColor="light"
          lineColor="light"
        >
          <WHowOrderRussianBox {...{ paths, data }} />
        </HowToBlock>
      )}
    </SectionWrapperStyled>
  )
}

WHowOrder.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

WHowOrder.defaultProps = {
  isSquareHidden: false,
}

export default WHowOrder
